import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useOutletContext } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import supabase from '../../supabase/supabase';

const SuperAdminRoute = () => {
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();
  const outletContext = useOutletContext();
  const [role, setRole] = useState(null);
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    if (!user?.id) {
      setIsFetching(false);
      return;
    }

    const fetchRole = async () => {
      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('role')
          .eq('id', user.id)
          .single();

        if (!error && data) {
          setRole(data.role);
        }
      } catch (err) {
        console.error('Error fetching role:', err);
      } finally {
        setIsFetching(false);
      }
    };

    fetchRole();
  }, [user?.id]);

  if (authLoading || isFetching) {
    return (
      <div className="h-full flex items-center justify-center w-full py-20">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-2 border-orange-500/20 border-t-orange-500 rounded-full animate-spin"></div>
          <div className="text-orange-500/50 text-sm font-medium tracking-widest uppercase animate-pulse">
            Verifying Access
          </div>
        </div>
      </div>
    );
  }

  // 1. If not logged in, redirect to login
  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // 2. If logged in but not superadmin, redirect to normal dashboard
  if (role !== 'superadmin') {
    return <Navigate to="/dashboard" replace />;
  }

  // 3. Otherwise, render the superadmin route content and pass through the parent context
  return <Outlet context={outletContext} />;
};

export default SuperAdminRoute;